'use client';

import { usePathname } from 'next/navigation';
import { useState } from 'react';

import {
    createItemsViewEvent,
    dataLayerPush,
    Events,
    getSearchStats,
    mapCategoriesFromUrl,
    PageSectionAnalyticsTracking,
} from '@libs/analytics';

import { mapYmalProductsToAnalyticsProducts } from '../lib';
import type { YmalProductsSectionTrackerProps } from './ymalProductsCarousel.types';

export function YmalProductsSectionTracker({ products, children }: Readonly<YmalProductsSectionTrackerProps>) {
    const [sentDataLayer, setSentDataLayer] = useState<boolean>(false);
    const pathname = usePathname();

    return (
        <PageSectionAnalyticsTracking
            sectionId="you-may-also-like-products-carousel"
            eventCallback={() => {
                dataLayerPush({
                    event: Events.VIEW_ITEM_LIST,
                    ...createItemsViewEvent(
                        mapYmalProductsToAnalyticsProducts(products),
                        'contentful',
                        'standard pdp',
                        mapCategoriesFromUrl(pathname),
                        getSearchStats().searchTerm
                    ),
                });
            }}
            enabled={!sentDataLayer}
            OnIntersect={() => setSentDataLayer(true)}
        >
            {children}
        </PageSectionAnalyticsTracking>
    );
}
